import { render, staticRenderFns } from "./PermissionsListTable.vue?vue&type=template&id=688ee8e8&scoped=true&"
import script from "./PermissionsListTable.vue?vue&type=script&lang=js&"
export * from "./PermissionsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ee8e8",
  null
  
)

export default component.exports